import { ICredentialService } from "../../service/credential/CredentialService";

export default class ConfirmPasswordResetInteractor {
  private credentialService: ICredentialService;

  constructor({
    credentialService
  }: {
    credentialService: ICredentialService;
  }) {
    this.credentialService = credentialService;
  }

  async execute(userId: string, code: string, language: string) {
    return this.credentialService.confirmPassword(userId, code, language);
  }
}
